import * as Yup from "yup";

const regexParaCelulares =
  /^(?:(?:00)?549?)?0?(?:11|[2368]\d)(?:(?=\d{0,2}15)\d{2})??\d{8}$/;

// const regexParaCUIT = /^(20|2[3-7]|30|3[3-4])(\d{8})(\d)$/;
// const regexParaDNI = /^[\d]{1,3}\.?[\d]{3,3}\.?[\d]{3,3}$/; Permite números con puntos, pero no es necesario
const regexParaDNI = /^[1-9]\d{6,7}$/;
// const regexParaDNICUIT =
//   /^(20|23|24|27|30|33|34|36|37|40|41|42|45|46|47|49)\d{8}(\d{1})$|^\d{8}$/;

export const validationLogin = Yup.object({
  username: Yup.string().required("Campo requerido"),
  password: Yup.string()
    .min(6, "Mínimo de 6 caracteres")
    .required("Campo requerido"),
});

export const validationFormulario = Yup.object({
  nombre: Yup.string().required("El nombre es requerido"),
  apellido: Yup.string().required("El apellido es requerido"),
  genero: Yup.string().required("El genero es requerido"),
  confirmados: Yup.array()
    .of(Yup.boolean())
    .test(
      "all-confirmed",
      "Debes confirmar todas las tarjetas",
      (value) => Array.isArray(value) && value.every((v) => v === true)
    ),
  email: Yup.string()
    .email("Debe ser un correo electrónico válido")
    .required("El email es requerido"),
  //tel: Yup.string().matches(regexParaCelulares, "Número telefónico no válido"),
  //.required("El teléfono es requerido"),
  telefonos: Yup.array()
    .of(
      Yup.object({
        tipo: Yup.string().required("El tipo es obligatorio"),
        numero: Yup.string()
          .required("El número es obligatorio")
          .matches(regexParaCelulares, "Número telefónico no válido")
          .min(6, "Debe tener al menos 6 dígitos")
          .max(15, "Máximo 15 dígitos"),
      })
    )
    .min(1, "Debe haber al menos un teléfono")
    .test(
      "al-menos-uno-valido",
      "Debe cargar al menos un teléfono válido",
      (value) =>
        Array.isArray(value) && value.some((t) => t?.numero?.trim())
    ),
  //tipoDoc: Yup.string().required("El tipo es requerido"),
  documento: Yup.string()
    .matches(regexParaDNI, "Número de DNI no válido")
    .required("El documento es requerido"),
  //propiedad: Yup.string().required("La propiedad es requerida"),
  provincias: Yup.string().required("La provincia es requerida"),
  departamentos: Yup.string().required("El departamento es requerido"),
  localidades: Yup.string().required("La localidad es requerida"),
  calle: Yup.string(),
  puerta: Yup.number().when("calle", {
    is: (calle) => !!calle, // solo valida si calle tiene valor
    then: (schema) =>
      schema
        .typeError("Debe ser un número") // por si escriben texto
        .required("La altura es requerida")
        .min(1, "Mínimo debe ser 1"),
    otherwise: (schema) => schema.notRequired(),
  }),
  piso: Yup.number(),
  dpto: Yup.string(),
  segmento: Yup.number(),
  sucursal: Yup.number().required("La sucursal es requerida"),
  ubicacion: Yup.string().test(
    "calle-o-ubicacion",
    "Debes completar al menos Calle o Ubicación",
    function (value) {
      const { calle } = this.parent; // accede a los otros valores
      return Boolean(value || calle); // pasa si al menos uno existe
    }
  ),
  planComercial: Yup.string().required("El plan es requerido"),
});

// Solicitud de servicio (prospecto en zona sin servicio). Mínimos obligatorios:
// nombre, apellido, un teléfono, provincia, localidad y al menos calle o
// referencia. DNI, email y género son opcionales (es un prospecto, no un alta).
export const validationSolicitud = Yup.object({
  nombre: Yup.string().trim().required("El nombre es requerido"),
  apellido: Yup.string().trim().required("El apellido es requerido"),
  documento: Yup.string().matches(regexParaDNI, {
    message: "Número de DNI no válido",
    excludeEmptyString: true,
  }),
  genero: Yup.string(),
  email: Yup.string().email("Debe ser un correo electrónico válido"),
  telefonos: Yup.array()
    .of(
      Yup.object({
        tipo: Yup.string().required("El tipo es obligatorio"),
        numero: Yup.string()
          .required("El número es obligatorio")
          .matches(regexParaCelulares, "Número telefónico no válido")
          .min(6, "Debe tener al menos 6 dígitos")
          .max(15, "Máximo 15 dígitos"),
      })
    )
    .min(1, "Debe haber al menos un teléfono")
    .test(
      "al-menos-uno-valido",
      "Debe cargar al menos un teléfono válido",
      (value) => Array.isArray(value) && value.some((t) => t?.numero?.trim())
    ),
  provincia: Yup.string().trim().required("La provincia es requerida"),
  localidad: Yup.string().trim().required("La localidad es requerida"),
  calle: Yup.string(),
  altura: Yup.string(),
  piso: Yup.string(),
  dpto: Yup.string(),
  referencia: Yup.string()
    .max(500, "Máximo 500 caracteres")
    .test(
      "calle-o-referencia",
      "Completá al menos la calle o una referencia",
      function (value) {
        return Boolean(value || this.parent.calle);
      }
    ),
});
